<template>
  <div :title="params.value">
    <div v-if="showLink">
      <a :href="link">
        {{ params.value }}
      </a>
    </div>
    <div v-else>
      {{ display }}
    </div>
  </div>
</template>

<script>
import cellRendererMixin from '../../mixins/cellRenderer.mixin'

export default {
  mixins: [cellRendererMixin],
  data: function() {
    return {
      value: null
    }
  },
  computed: {
    showLink() {
      return this.params.renderAsLink || false
    },
    link() {
      let email = `mailto:${this.params.value}`
      let query = ''
      if (this.params.mailDetails) {
        query += this.params.mailDetails.subject ? `&subject=${this.params.mailDetails.subject}` : ''
        query += this.params.mailDetails.body ? `&body=${this.params.mailDetails.body}` : ''
        query += this.params.mailDetails.cc ? `&cc=${this.params.mailDetails.cc.map(cc => cc).join(',')}` : ''
        query += this.params.mailDetails.bcc ? `&bcc=${this.params.mailDetails.bcc.map(bcc => bcc).join(',')}` : ''
      }

      return query ? email + '?' + query : email
    }
  }
}
</script>
